import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LikeTypesPicker from './likeTypesPicker';

class LikeButton extends Component {

  constructor(props) {
    super(props);

    this.state = { showingLikeTypesPicker: false };

    this.handleToggleLike = this.handleToggleLike.bind(this);
    this.handleLikeTypePicked = this.handleLikeTypePicked.bind(this);
  }

  handleToggleLike(event) {
    event.preventDefault();

    if (!this.props.likeLoadingStatus) {
      if (this.props.currentUserLike) {
        this.props.onUnliked(this.props.currentUserLike);
      } else {
        this.setState({ showingLikeTypesPicker: true });
      }
    }
  }

  handleLikeTypePicked(likeType) {
    if (!this.props.likeLoadingStatus) {
      this.setState({ showingLikeTypesPicker: false });
      this.props.onLiked(likeType);
    }
  }

  render() {
    const buttonText = this.props.currentUserLike ? `Unlike (${this.props.currentUserLike.likeType.name})` : 'Like';

    if (this.props.likeLoadingStatus) {
      return (
        <span>{this.props.likeLoadingStatus}</span>
      );
    } else {
      return (
        <div>
          {this.state.showingLikeTypesPicker && 
            <LikeTypesPicker likeTypes={this.props.likeTypes} onLikeTypePicked={this.handleLikeTypePicked} />}
          <button onClick={this.handleToggleLike}>{buttonText}</button>
        </div>
      );
    }
  }

}

LikeButton.propTypes = {
  currentUserLike: PropTypes.object,
  onLiked: PropTypes.func.isRequired,
  onUnliked: PropTypes.func.isRequired,
  likeLoadingStatus: PropTypes.string
};

export default LikeButton;


// WEBPACK FOOTER //
// ./src/views/likeButton.js